import * as React from "react";
import Dialog from "@mui/material/Dialog";

const DeleteConfirmationBox: React.FC<{
  openDeleteConfirmationBox: {
    isOpen: boolean;
    guid: string;
    displayName: string;
  };
  deleteHandler: any;
  closeDeleteConfirmationBoxHandler: () => void;
  loading?: boolean;
}> = ({
  openDeleteConfirmationBox,
  deleteHandler,
  closeDeleteConfirmationBoxHandler,
  loading = false,
}) => {
  const [confirmText, setConfirmText] = React.useState("");

  const deleteModuleCaller = async () => {
    try {
      deleteHandler();
    } catch (error) {
      console.error("Error deleting module:", error);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmText(event.target.value);
  };
  React.useEffect(() => {
    setConfirmText("");
  }, [openDeleteConfirmationBox.isOpen]);

  return (
    <Dialog
      open={openDeleteConfirmationBox.isOpen}
      onClose={closeDeleteConfirmationBoxHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="p-4">
        <h5 className="mb-3">
          To delete the module, please type{" "}
          <b>{openDeleteConfirmationBox.displayName}</b>
        </h5>
        <input
          type="text"
          className="form-control"
          value={confirmText}
          onChange={handleInputChange}
          placeholder={
            "Type '" +
            openDeleteConfirmationBox.displayName +
            "' to confirm deletion"
          }
        />
        <div className="d-flex justify-content-end mt-2">
          <div>
            <button
              className="btn btn-secondary mt-2 mx-2"
              onClick={closeDeleteConfirmationBoxHandler}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              className="btn btn-danger mt-2 mx-auto"
              onClick={deleteModuleCaller}
              disabled={
                confirmText !== openDeleteConfirmationBox.displayName || loading
              }
            >
              Delete
            </button>
          </div>
        </div>{" "}
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationBox;
